import TamanioShow from './TamanioShow'
export {TamanioShow}
export default TamanioShow
